<div
    class="content-with-side-menu"
    [style.margin-bottom.px]="bottomMenuHeight()"
>
    <div class="row no-gutters">
        <div class="col-md-auto">
            <app-camp-search-criteria
                hznTestId="camp-list-filters"
                [filters]="filters"
                [searchForm]="searchForm"
            ></app-camp-search-criteria>
        </div>

        <div class="col">
            <div
                class="row no-gutters top-panel height-80 line-height-40 padding-20"
            >
                <div class="col" [formGroup]="searchForm">
                    <div class="form-check form-check-inline">
                        <input
                            hznTestId="camp-list-status-draft"
                            formControlName="showDraft"
                            class="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox1"
                            value="option1"
                        />
                        <label
                            class="form-check-label main-orange bolded"
                            for="inlineCheckbox1"
                            >{{ "CampStatus.Draft" | translate }}</label
                        >
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            hznTestId="camp-list-status-active"
                            formControlName="showActive"
                            class="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox2"
                            value="option2"
                        />
                        <label
                            class="form-check-label main-green bolded"
                            for="inlineCheckbox2"
                            >{{ "CampStatus.Active" | translate }}</label
                        >
                    </div>

                    <div class="form-check form-check-inline">
                        <input
                            hznTestId="camp-list-status-closed"
                            formControlName="showClosed"
                            class="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox3"
                            value="option3"
                        />
                        <label
                            class="form-check-label main-blue bolded"
                            for="inlineCheckbox3"
                            >{{ "CampStatus.Closed" | translate }}</label
                        >
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            hznTestId="camp-list-status-removed"
                            formControlName="showRemoved"
                            class="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox4"
                            value="option4"
                        />
                        <label
                            class="form-check-label text-dark bolded"
                            for="inlineCheckbox4"
                            >{{ "CampStatus.Removed" | translate }}</label
                        >
                    </div>
                </div>
                <div class="col">
                    <div class="right">
                        <app-sort-camps
                            hznTestId="camp-list-sort"
                            [sorting]="sorting"
                            [model]="searchForm.controls['sorting'].value"
                            (changed)="search()"
                        ></app-sort-camps>
                    </div>
                </div>
            </div>

            <div>
                <bcu-local-spinner
                    [size]="50"
                    [visible]="isBusy"
                ></bcu-local-spinner>

                <div
                    class="list-group list-group-flush list-group-margin-bottom-60"
                >
                    @for (item of items; track item) {
                        <div
                            class="list-group-item list-group-item-action flex-column align-items-start clickable"
                            (click)="onItemSelected(item)"
                        >
                            <app-camp-list-row
                                hznTestId="camp-list-row"
                                [item]="item"
                            ></app-camp-list-row>
                        </div>
                    }
                </div>
                @if (noItems && !isBusy) {
                    <div class="no-items-info padding-20" hznTestId="camp-list-no-items">
                        <span>{{ "CampList.noItems" | translate }}</span>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
<div #bottomMenu class="bottom-menu">
    <button
        class="btn btn-success right"
        type="submit"
        bcShowIfPrivilegeDynamic="Camps.campsCanManage"
        bcClick
        hznTestId="camp-list-create"
        (clicked)="goToCreate()"
    >
        {{ "CampList.createNew" | translate }}
    </button>
    <button
        class="btn btn-primary right mr-2"
        type="submit"
        bcShowIfPrivilegeDynamic="Camps.campsCanManage"
        bcClick
        hznTestId="camp-list-import"
        (clicked)="goToImport()"
    >
        {{ "CampList.importFromFile" | translate }}
    </button>
</div>
